import { Navigate, useRoutes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

// config
import { mainRoutes } from './main';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { paths } from '../paths';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));
const JwtRegisterPage = lazy(() => import('src/pages/auth/jwt/register'));
const ResetPage = lazy(() => import('src/pages/auth/resetpassword'));
const ForgetPage = lazy(() => import(`src/pages/auth/forget`));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={paths.auth.login} replace />,
    },
    {
        path: 'login',
        element: (
          <AuthClassicLayout>
            <JwtLoginPage />
          </AuthClassicLayout>
        ),
      },
  
      {
        path: 'register',
        element: (
          <AuthClassicLayout title="">
            <JwtRegisterPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <AuthClassicLayout>
            <ResetPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'forget-password',
        element: (
          <AuthClassicLayout>
            <ForgetPage />
          </AuthClassicLayout>
        ),
      },
    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
